import { createContext, Dispatch, SetStateAction } from 'react'

import { User } from './types'

export const initUserForm: User = {
	email: '',
	role: 'VIEWER',
	name: '',
}

export const UserFormContext = createContext<{
	userForm: User
	setUserForm: Dispatch<SetStateAction<User>>
	formEdited: boolean
	setFormEdited: Dispatch<SetStateAction<boolean>>
	showError: boolean
	setShowError: Dispatch<SetStateAction<boolean>>
	isValid: boolean
	setIsValid: Dispatch<SetStateAction<boolean>>
}>({
	userForm: initUserForm,
	setUserForm: () => {},
	formEdited: false,
	setFormEdited: () => {},
	showError: false,
	setShowError: () => {},
	isValid: false,
	setIsValid: () => {},
})
